import axios, { AxiosResponse } from 'axios'

import { CSAreaId, CSAreaRead, CSAreaWrite } from '@generated/types'

const BASE = '/api/csarea'

export default {
  async listAreas(): Promise<AxiosResponse<CSAreaRead[]>> {
    return axios.get(`${BASE}`)
  },

  async createCSArea(data: CSAreaWrite): Promise<AxiosResponse<CSAreaRead>> {
    return axios.post(`${BASE}/`, data)
  },

  async updateCSArea(id: CSAreaId, data: CSAreaWrite): Promise<AxiosResponse<CSAreaRead>> {
    return axios.put(`${BASE}/${id}/`, data)
  },

  async updateImage(id: CSAreaId, data: FormData): Promise<AxiosResponse<CSAreaRead>> {
    return axios.put(`${BASE}/${id}/set_photo/`, data)
  },

  async deleteCSArea(id: CSAreaId): Promise<AxiosResponse> {
    return axios.delete(`${BASE}/${id}/`)
  },
}
